/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_PatternInputs */

const vi_weighing_pattern = /** @type {(inputs: Weighing_PatternInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu`)
};

/**

* @param {Weighing_PatternInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_pattern = /** @type {((inputs?: Weighing_PatternInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_PatternInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_pattern(inputs)
});